import { render, staticRenderFns } from "./IncidencesTable.vue?vue&type=template&id=2e48b1af&"
import script from "./IncidencesTable.vue?vue&type=script&lang=js&"
export * from "./IncidencesTable.vue?vue&type=script&lang=js&"
import style0 from "./IncidencesTable.vue?vue&type=style&index=0&id=2e48b1af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports